import { I18n } from "@assets/strings";
import React from "react";
import { Group } from "@domain/group/group";
import { useGroupMembers } from "@domain/user/hooks";
import { MembersList } from "@ui/components/profile/community/memberList";

interface GroupMembersListProps extends React.HTMLAttributes<HTMLDivElement> {
	group: Group;
	onShouldSeeMore: () => void;
}
export const GroupMembersList: React.FC<GroupMembersListProps> = ({ group, onShouldSeeMore, ...htmlProps }) => {
	const { result: teachers, totalElements } = useGroupMembers(group.id, "MEMBER");

	return (
		<MembersList
			{...htmlProps}
			members={teachers}
			totalElements={totalElements}
			onShouldSeeMore={onShouldSeeMore}
			title={I18n.t("group.members.list.title", { count: totalElements ?? 0 })}
			emptyText={I18n.t(`group.${group.type}.members.list.empty`)}
		/>
	);
};
